import { AppModal } from 'components/molecules';
import { UsersSlash } from 'assets';
import styled from 'styled-components';
import { commonTexts, enrollmentTexts } from 'consts/text';
import { AppButton, AppParagraph } from 'components/atoms';

const IconContainer = styled.div`
    margin-block-start: 16px;
`;

type EnrollmentErrorModalType = {
    open: boolean;
    onClose: () => void;
};

export const EnrollmentErrorModal = ({ onClose, open }: EnrollmentErrorModalType) => (
    <AppModal
        width={300}
        icon={
            <IconContainer>
                <UsersSlash />
            </IconContainer>
        }
        open={open}
        title={enrollmentTexts.errorModal.title}
        onCancel={onClose}
        isMobileFullScreenMode={false}
    >
        <AppParagraph textAlign="center" textType="BodyMedium" margin={0}>
            {enrollmentTexts.errorModal.message}
        </AppParagraph>
        <AppButton
            size="large"
            danger
            type="primary"
            block
            marginLeft={0}
            marginRight={0}
            marginTop={32}
            onClick={onClose}
        >
            {commonTexts.actionLabels.agree}
        </AppButton>
    </AppModal>
);
